module.exports = __webpack_public_path__ + "img/IMG_20200707_232854.6e02a1ee.jpg";